import React from 'react'

const CrossedMobileIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <div
      style={{
        display: 'flex',
        padding: '24px',
        height: '100px',
        width: '100px',
        background: '#eef0f8',
        alignItems: 'center',
        borderRadius: '50%'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30" version="1.1">
        <g
          id="admin-UI"
          stroke={color}
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <g id="Chat-UI-3-stoppers" transform="translate(-936, -367)">
            <g id="mobile" transform="translate(938.7444, 369.5)">
              <path
                d="M4.75558553,4.81150655 L4.75558553,3 C4.75558553,1.34314575 6.09873128,7.48448398e-16 7.75558553,4.4408921e-16 L16.7555855,0 C18.4124398,-3.04359188e-16 19.7555855,1.34314575 19.7555855,3 L19.7555855,19.7715791 L19.7555855,19.7715791"
                id="Rectangle"
                stroke="#202020"
              />
              <path
                d="M19.7555855,22.42756 C19.7555855,23.8482794 18.6038649,25 17.1831455,25 L7.75558553,25 C6.09873128,25 4.75558553,23.6568542 4.75558553,22 L4.75558553,8.125 L4.75558553,8.125"
                id="Rectangle"
                stroke="#202020"
              />
              <line
                x1="12.8680855"
                y1="20.625"
                x2="12.8930855"
                y2="20.625"
                id="Path"
                stroke="#000000"
                stroke-width="2.25"
              />
              <line x1="0" y1="0" x2="24.1305855" y2="24.375" id="Path-2" stroke="#202020" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

export default CrossedMobileIcon
